import CommonApi from "../common/CommonApi";
import axios from "axios";
import SuccessResponse from "../dto/common/SuccessResponse";
import FranchiseDto from "../dto/franchise/FranchiseDto";
import FranchiseListDto from "../dto/franchise/FranchiseListDto";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import FranchiseSaveReqDto from "../dto/franchise/FranchiseSaveReqDto";
import FranchiseSaveRespDto from "../dto/franchise/FranchiseSaveRespDto";
import FranchiseUpdateReqDto from "../dto/franchise/FranchiseUpdateReqDto";

class RealFranchiseApi extends CommonApi {
    async getFranchiseList({
        page,
        pageSize,
        franchiseCode,
        franchiseName,
    }: {
        page: number;
        pageSize: number;
        franchiseCode: string;
        franchiseName: string;
    }): Promise<SuccessResponse<FranchiseListDto>> {
        const baseHeaders = this.makeBaseHeader();

        const query: Record<string, any> = {
            page: page,
            pageSize: pageSize,
        };
        if (franchiseCode !== "") {
            query.franchiseCode = franchiseCode;
        } else if (franchiseName !== "") {
            query.franchiseName = franchiseName;
        }

        await axios.options(`${this.BASE_SERVICE_URL}/franchise`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<FranchiseListDto>>(`${this.BASE_SERVICE_URL}/franchise`, {
            headers: baseHeaders,
            params: query,
        });

        return response.data;
    }

    async saveFranchise(
        reqDto: CommonRequestBodyDto<FranchiseSaveReqDto>
    ): Promise<SuccessResponse<FranchiseSaveRespDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/franchise`, {
            headers: baseHeaders,
        });

        const response = await axios.post<SuccessResponse<FranchiseSaveRespDto>>(
            `${this.BASE_SERVICE_URL}/franchise`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }
    async getFranchiseInfo({
        countryCode,
        franchiseCode,
    }: {
        countryCode: string;
        franchiseCode: string;
    }): Promise<SuccessResponse<FranchiseDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/franchise/info`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<FranchiseDto>>(`${this.BASE_SERVICE_URL}/franchise/info`, {
            headers: baseHeaders,
            params: { countryCode, franchiseCode },
        });

        return response.data;
    }

    async updateFranchise(
        reqDto: CommonRequestBodyDto<FranchiseUpdateReqDto>
    ): Promise<SuccessResponse<FranchiseSaveRespDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/franchise`, {
            headers: baseHeaders,
        });

        const response = await axios.put<SuccessResponse<FranchiseSaveRespDto>>(
            `${this.BASE_SERVICE_URL}/franchise`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async deleteFranchise({ idFranchise }: { idFranchise: number }): Promise<SuccessResponse<string>> {
        const baseHeaders = this.makeBaseHeaderWithClientVersion({ xApiVersion: 3.2 });

        await axios.options(`${this.BASE_SERVICE_URL}/franchise?idFranchise=${idFranchise}`, {
            headers: baseHeaders,
        });

        const response = await axios.delete<SuccessResponse<string>>(
            `${this.BASE_SERVICE_URL}/franchise?idFranchise=${idFranchise}`,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async checkFranchiseCode({ franchiseCode, countryCode }: { franchiseCode: string; countryCode: string }) {
        const baseHeaders = this.makeBaseHeader();

        const response = await axios.get<SuccessResponse<FranchiseDto>>(`${this.BASE_SERVICE_URL}/franchise/info`, {
            headers: baseHeaders,
            params: { countryCode, franchiseCode },
        });

        return response.data;
    }
}

export default RealFranchiseApi;
